export default {
  feedback: {
    usage_threshold: 'Mindestbestellwert für diese Promo beträgt (abz. Lieferkosten & Trinkgeld)',
    promo_code_added: 'Promo Code angewendet',
    promo_code_removed: 'Gutscheincode {{code}} wurde entfernt',
  },
};
